/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ChecklistItemType {
    YesNoOption = 0,
    ThreeStarOption = 1,
    FreeAnswerOption = 2,
    SingleChoiceOption = 3,
    MultipleChoiceOption = 4,
}
